// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"6e4fda3a","288":"e6f8606a"}[chunkId] + ".chunk.css";
};